import React, { useContext } from "react";

import { storageHelper } from "lib/helpers";
import constant from "lib/constant/constant";
import { PrivateContext } from "lib/context";
import OperatorQuickLink from "./operator/widgets/quickLink/quickLink";
import ProviderQuickLink from "./provider/widgets/quickLink/quickLink";
import AdminQuickLink from "./admin/widgets/quickLinks/quickLinks";

const { userKey } = constant;
const { admin, operator, provider } = userKey;

const QuickLinks = (props) => {
  const { link = [] } = props;
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (isLoading) {
      return null;
    }
    if (role === admin) {
      return <AdminQuickLink />;
    }
    if (role === operator) {
      return <OperatorQuickLink link={link} />;
    }
    if (role === provider) {
      return <ProviderQuickLink link={link} />;
    }
    return null;
  };

  const currentUserRole = storageHelper.get("userRole");
  const QuickLinksComponent = getComponent(currentUserRole);
  return QuickLinksComponent;
};

export default QuickLinks;
